// extracted by mini-css-extract-plugin
export var parcelRow = "_tj-0";